module.exports = __webpack_public_path__ + "static/media/pic_banner_loyaltyProvider.540f9c64.jpg";